var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3146 21.1378C9.49715 25.6576 8.11881 28.9111 7.02895 30.9306C6.59621 31.7159 7.47773 32.5974 8.24705 32.1486C17.3827 26.8276 21.3895 19.0703 21.8863 12.8356C22.3191 7.46645 18.6489 1.937 13.1033 0.927282C7.55787 -0.0824432 2.23677 3.60387 1.22705 9.14929C0.169243 14.9673 4.27225 20.5608 10.3146 21.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.089 21.1378C32.2716 25.6576 30.8932 28.9111 29.8034 30.9306C29.3706 31.7159 30.2522 32.5974 31.0215 32.1486C40.1571 26.8276 44.164 19.0703 44.6608 12.8356C45.0936 7.46645 41.4232 1.937 35.8778 0.927282C30.3323 -0.0824432 25.0112 3.60387 24.0015 9.14929C22.9437 14.9673 27.0468 20.5608 33.089 21.1378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9861,
    height: 32.39,
    fill: "white",
    transform: "translate(0.396973 0.0600586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewQuote);
export default __webpack_public_path__ + "static/media/Review_Quote.8e4fd3036ca06560f9fa873ec27a6476.svg";
export { ForwardRef as ReactComponent };